export default __webpack_public_path__ + "static/couplewalking-316b19b34810cc4dac33d9e92e15f144.png";